











import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

@Component
export default class InfiniteScrollList extends Vue {
  @Prop()
  dataSource: any[]
  @Prop()
  disabled: boolean
  @Prop()
  loading: boolean
  @Prop()
  height: number | string

  get listHeight() {
      return _.isNumber(this.height) ? `${this.height}px` : this.height
  }

  get isFulfilled() {
      return !this.loading
  }

  get isEmpty() {
      return this.dataSource.length === 0 && this.isFulfilled
  }

  get isNotMore() {
      return this.dataSource.length > 0 && this.isFulfilled && this.disabled
  }

  get tips() {
      if (this.loading) {
          return '加载中...'
      } else if (this.isEmpty) {
          return `<span style="display: inline-block;margin-top: 40px">暂无数据</span>`
      } else if (this.isNotMore) {
          return '没有更多数据'
      }
      return ''
  }

  @Emit('load')
  onLoad() {

  }
}
